import './panel.scss';
import "../../shared/styles/_globals.scss";
import "../../shared/styles/_colors.scss";
import colors from '../../assets/scss/variable/color.scss';
import {Link, Outlet} from "react-router-dom";
import React, {Component, createRef} from 'react';
import Storage from "../../helpers/Storage";
import Modal from "react-bootstrap/Modal";
import Textbox from "../../shared/component/textbox/Textbox";
import {connect} from "react-redux";
import Validation from "../../helpers/Validation";
import Login from "../../core/api/user/Login";
import {_alert} from "../../actions/Alert";
import {_loading} from "../../actions/Loading";
import UserSettings from "../../core/constants/UserSettings";
import {withRouter} from "../../helpers/withRouter";
import {updateDownloadCount} from "../../actions/PanelHeader";
import Convert from "../../helpers/Convet";
import {handleChangeLang} from "../../actions/Lang";
import {handleChangeCalendar} from "../../actions/Calendar";
import T from "../../shared/component/t/T";
import config from "../../config";
import eventBus from "../../core/utils/EventBus";
import SigninModal from "../Auth/signin/SigninModal";
import Uploader from '../../shared/component/uploader/Uploader';
import Navbar from './Header/Navbar/Navbar';
import AddPatient from '../../shared/Subsystems/AddPatient/AddPatient';
import User from '../../core/api/User2/User';
import Exports from '../../core/api/Exports/Exports';
import ProgressBar from '../../shared/component/ProgressBar/ProgressBar';
import {handleChangeDoubleClickAction} from "../../actions/UserSettings";
import CheckBox from "../../shared/component/CheckBox/CheckBox";
import {default as _} from "../../helpers/Translate"
import snippets from "../../helpers/snippets";
import Tooltip from "../../shared/component/Tooltip/Tooltip";
import {default as user1} from "../../helpers/User"
import { gsap } from 'gsap';
import ChangesLogReducer from "../../reducers/ChangesLogReducer";
import BaseApi from "../../core/api/BaseApi";
import ChangesGroup from "./changes/ChangesGroup";
import LastLogin from "./Last-sessions/LastLogin";
import otp from '../../assets/images/otp.svg'
import LastLoginModal from "./Last-sessions/LastLoginModal";
import Button from "../../shared/component/button/Button";

const login = new Login();
const baseApi = new BaseApi()
const user = new User();
const exports = new Exports();

class Panel extends Component {


    input = {
        current_password:'',
        password: '',
        confirm_password:''
    };

    validators = {
        current_password:['required'],
        password: ['required'],
        confirm_password: ['required']
    };

    constructor(props) {
        super(props);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleUpdateDownloadCount = this.handleUpdateDownloadCount.bind(this);
        this.handleMakeLink = this.handleMakeLink.bind(this);
        this.handleChangePass = this.handleChangePass.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSaveSettings = this.handleSaveSettings.bind(this);
        this.handleDownloadFile = this.handleDownloadFile.bind(this);
        this.toggleHandler = this.toggleHandler.bind(this);

        this.iconRef1 = createRef();
        this.iconRef2 = createRef();
        this.animation = null;
        this.textRef = createRef();
        this.animation2 = null;

        this.exportStatusTimer = 0;

        this.state = {
            input: this.input,
            scroll: null,
            hideByScrolling: true,
            serverChangePassErrors: [],
            user: {...Storage.getUserInfo(), updated_at: Storage.getUpdatedAt()},
            isPublic: user1.UserIsPublic(),
            dropdown_profile: false,
            device: this.props.device,
            modalProfile: false,
            modalSettings: false,
            modalSignature: false,
            downloadCount: 0,
            downloadStep1: true,
            downloadStep2: false,
            downloadStep3: false,
            calendar: null,
            preDownload: null,
            doubleClick: Storage.getUserDoubleClick(),
            allowResidentsToVerifyWithMe: Storage.getUserAllowResidentToVerify(),
            lastScrollTop: 0,
            downloadFiles: [],
            downloadOptions: {includeViewer: 'none', includeReport: false, anonymous: false, compressedFormat: "ZIP", fileType: "dcm" },
	        includeViewerOptions: ['none', ...Storage.getViewersOptions()],
	        includeViewerDisabled: false,
            filesSize: 0,
            filesCount: 0,
            downloadPercent: 0,
            downloadComplete: false,
            owner: config.owner,
            sessionExpired: false,
            profileDrillDownIsOpen: false,
            showAddPatient: false,
            language: this.props.language,
            hospitalName: Storage.getHospitalName(),
            canDownload: false,
            disableDownloadButton: false,
            compressPercent: 0,
            userSignature: null,
            uploaderUploadAFile: 0,
            changes: {show: false, loading: false, logs: []},
	        modalLastSession: false,
	        modalOTP: false,
	        verifyOTP: false
        };
    }

    componentDidMount() {
        document.title = _.init4("title_homepage", {hospital: this.state.hospitalName}, this.state.language);
        this.setUserSettings();
        eventBus.on("sessionExpired", () => {this.signinModalOpener()});
        this.animation = gsap.fromTo([this.iconRef1.current, this.iconRef2.current],
            { color: colors.primary },
            { duration: 0.5, color: colors.white, repeat: -1, yoyo: true , paused: true}
        )
        this.animation2 = gsap.fromTo(this.textRef.current,
            { color: colors.white },
            { duration: 0.5, color: colors.primary, repeat: -1, yoyo: true , paused: true}
        )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.handleUpdateDownloadCount(prevProps, this.props);
        if (prevProps.language !== this.props.language) {
            this.setState({language: this.props.language});
        }
        if (this.state.changes.logs !== this.props.changes) {
			let current = this.getLastChangesID(this.props.changes)
	        let seen = Storage.getUserChangeLogVersion()
			if (this.canSeeChangeLogs(+current, +seen, this.state.isPublic)) {
				this.setState({changes: {...this.state.changes,
						show: !snippets.isObjectEmpty(this.props.changes),
						logs: this.props.changes
					}
				}, () => {})
			}
        }
        if (prevProps.device !== this.props.device) {
            this.setState({device: this.props.device})
        }
        if (prevProps.scroll !== this.props.scroll) {
            this.setState({scroll: this.props.scroll} ,()=>{
                if (this.state.device !== "desktop"){
                    if (this.props.scroll === 'up' ) {
                        this.setState({ hideByScrolling: true}, ()=>{ })
                    } else if (this.props.scroll === 'down') {
                        this.setState({hideByScrolling: false}, ()=>{ })
                    }
                } else {
                    this.setState({ hideByScrolling: true}, ()=>{ })
                }
            })
        }
    }

    componentWillUnmount(){
    }
	
	canSeeChangeLogs = (current, seen, public_user) => {
		if (public_user && current > seen) return true
		else if (isNaN(seen)) return true
		else if (!public_user) return true
		return false
	}
	
	getLastChangesID = (changes) => {
		let last_version = changes?.[changes?.length-1]?.changes
		return last_version?.[last_version?.length -1]?.id
	}

    handleMouseEnter = () => {
        this.animation.play();
        this.animation2.play();
    }

    handleMouseLeave = () => {
        this.animation.pause();
        this.animation2.pause();
    }

    setUserSettings() {
        this.setState(Storage.getUserSettings());
    }

    handleShowModal(modal) {
        if (modal === 'modalDownload') {
            this.setState({
                downloadStep1: true,
                downloadStep2: false,
                downloadStep3: false,
            }, () => {
                this.setState({
                    [modal]: true
                });
            })
        } else {
            this.setState({
                [modal]: true
            });
        }
    }

    handleSignatureModal = () => {
        let signatureImage = user.getUserSignature({userID: this.state.user.id, eTag: this.state.user.updated_at});

        this.setState({
            userSignature: signatureImage,
            modalSignature: true
        });
    }

    updateFromUploader = (previewFile) => {
        this.setState({
            userSignature: previewFile
        });
    }

    handleOpenDrillDown = () => {
        this.setState({
            profileDrillDownIsOpen: true
        });
    }

    handleCloseDrillDown = () => {
        this.setState({
            profileDrillDownIsOpen: false
        });
    }

    handleCloseModal(modal) {
        this.setState({
            [modal]: false
        });
    }

    handleShowDropdown(state, dropdown) {
        this.setState({
            [dropdown]: state
        });
    }

    handleUpdateDownloadCount(prevProps, thisProps) {
        if (prevProps.downloadCount !== thisProps.downloadCount) {
            this.setState({
                downloadCount: thisProps.downloadCount.downloadCount.length,
                downloadFiles: thisProps.downloadCount.downloadCount,
                filesSize: this.initFileSize(thisProps.downloadCount.downloadCount),
                filesCount: this.initFileCount(thisProps.downloadCount.downloadCount),
            },()=>{});
        }
    }

    initFileSize(data) {
        let size = 0;
        for (let dt of data) {
            size += dt.study.file_size_cache;
        }
        return Convert.B2GB(size);
    }

    initFileCount(data) {
        let count = 0;
        for (let dt of data) {
            count += dt.study.file_count_cache;
        }
        return count;
    }

    handleMakeLink() {
        if (this.state.disableDownloadButton) {
            return;
        }
        let studyIDs = [];

        for (let file of this.state.downloadFiles) {
            studyIDs.push({uid: file.study.id});
        }

        this.setState({
            disableDownloadButton: true
        }, () => {
            exports.begin({
                fileFormat: this.state.downloadOptions.fileType,
                viewer: this.state.downloadOptions.includeViewer === 'none' ? false : this.state.downloadOptions.includeViewer,
                studies: studyIDs,
                anonymous: this.state.downloadOptions.anonymous,
                media: {
                    report: this.state.downloadOptions.includeReport ? "pdf" : '',
                    size: null,
                    studiesUids: [],
                    type: this.state.downloadOptions.compressedFormat
                }
            }).then(response => {
                const {job_id, jobId} = response.data;
    
                this.handleExportStatus(jobId);
            }).catch(error => console.log(error));
        });
    }

    handleExportStatus = (jobID) => {
        if (this.exportStatusTimer) {
            clearTimeout(this.exportStatusTimer);
        }

        exports.status({
            studyID: jobID
        }).then(response => {
            if (response.data.status === "finished") {
                this.setState({
                    canDownload: jobID,
                    disableDownloadButton: false,
                    downloadStep2: true,
                    downloadStep1: false,
                    compressPercent: 0
                }, () => {
                    this.props.dispatch(_alert(true, 'success', <T token="create_link_successed" />));
                });
            }

            if (response.data.status === "processing") {
                this.setState({
                    compressPercent: parseInt(response.data.percent)
                });
                this.exportStatusTimer = setTimeout(() => this.handleExportStatus(jobID), 500);
            }

            if (response.data.status === "error") {
                this.setState({
                    disableDownloadButton: false,
                }, () => {
                    this.props.dispatch(_alert(true, 'error', response.data.message));
                });
            }
        }).catch(error => console.log(error));
    }

    changeHandler(event) {
        let nam = event.target.name;
        let val = event.target.value;
        Object.assign(this.input, {[nam]: val});
        this.setState({input: this.input, serverChangePassErrors:[]});
    }

    handleChangePass() {
        let errors = {
            current_password:'',
            password: '',
            confirm_password:''
        };
        let hints = {
            current_password:'',
            password: '',
            confirm_password:''
        };
        let validationResult = Validation.validate(this.state.input, errors, hints, this.validators);

        if (this.state.input.password !== this.state.input.confirm_password){
            validationResult.errorCount += 1
            this.setState({serverChangePassErrors:[_.init("password_confirm_not_match")]})
        }
        this.setState({
            errorData: {'counter': validationResult.errorCount, 'errors': validationResult.errors, 'hints': validationResult.hints}
        });

        if (!validationResult.errorCount) {
            const { confirm_password, ...updatedObject } = this.state.input;
            login.editData(updatedObject).then((response) => {
                this.handleCloseModal('modalProfile');
                this.props.dispatch(_alert(true, 'success', response.data.message));
            }).catch((xhr) => {
                this.setState({serverChangePassErrors:[xhr.response.data?.msg]})
            });
        }
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleDownloadOptionChangeCheckBoxes = (e) => {
        this.setState({
            downloadOptions: {...this.state.downloadOptions, [e.target.name]: e.target.checked}
        });
    }

    handleSaveSettings() {
        this.props.dispatch(_loading(true));

        let message = {
            type: "",
            text: ""
        };

        let _data = {
            calendar: this.state.calendar,
            language: this.state.language,
            pre_download: this.state.preDownload,
            double_click_action: this.state.doubleClick,
            allow_residents_to_verify_with_me: this.state.allowResidentsToVerifyWithMe
        };
        login.editData(_data).then((response) => {
            Storage.setEditLogin(response)
            this.props.dispatch(handleChangeLang(_data.language));
            this.props.dispatch(handleChangeCalendar(_data.calendar));
            this.props.dispatch(handleChangeDoubleClickAction(_data.double_click_action));
            message.type = "success";
            message.text = response.data.message;
            this.handleCloseModal('modalSettings');
        }).catch((xhr) => {
            message.type = "error";
            message.text = xhr.response.data.msg;
        }).finally(() => {
            this.props.dispatch(_loading(false));
            this.props.dispatch(_alert(true, message.type, message.text));
        });
    }

    handleLogout() {
	    baseApi.fullFetch('login', 'delete').then(response => {
        }).finally(()=> {
            Storage.removeStorageData();
            this.props.navigate("/signin");
	    })
    }

    initModalities(modalities) {
        const modalitiesArr = modalities.split(',');
        return modalitiesArr.map((modality, index) => {
            return <div key={index} className={'__value'}>{modality}</div>
        });
    }

    handleDownloadOptionChangeSelectOptions = (e) => {
        this.setState({
            downloadOptions: this.handleIncludeViewerOrNot({...this.state.downloadOptions, ...this.handleOptionsSituation(e)})
        }, ()=> {});
    }

    handleOptionsSituation = (e) => {
        let value = e.target.value
        let res = {[e.target.name]: e.target.value}
        if (this.state.downloadOptions.fileType?.includes("jpg") && value === "ISO"){
            res = {...res, fileType: "dcm"}
        } else if (this.state.downloadOptions.compressedFormat === "ISO" && value?.includes("jpg")){
            res = {...res, compressedFormat: "ZIP", includeReport: "none"}
        }
        return res
    }
	
	handleIncludeViewerOrNot = (downloadOptions) => {
		if (downloadOptions.fileType === 'dcm'){
			this.setState({includeViewerDisabled: false}, ()=>{})
	    } else {
			downloadOptions = {...downloadOptions, includeViewer: 'none'}
			this.setState({includeViewerDisabled: true}, ()=>{})
		}
		return downloadOptions
	}

    handleDownloadFile() {
        if (this.state.canDownload !== false) {
			this.props.dispatch(updateDownloadCount([]));
            window.open(`/1/export/download?id=${this.state.canDownload}&volume_id=1`, "_blank");
        }
    }

    signinModalCloser = () => {
        this.setState({
            sessionExpired: false
        }, () => {
            eventBus.dispatchEvent("sessionRevoked");
        });
    }

    signinModalOpener = () => {
        this.setState({
            sessionExpired: true
        });
    }

    toggleHandler(relatedStateVariable = "", value = false) {
        this.setState({
            [relatedStateVariable]: value
        });
    }
    
    toggleAddPatient = () => {
        this.setState({
            showAddPatient: !this.state.showAddPatient
        });
    }
    deleteFromDownload(index){
        let someProperty = this.state.downloadFiles
        someProperty.splice(index, 1);
        this.setState({downloadFiles: someProperty , downloadCount: this.state.downloadCount-1},()=>{
            //TODO: Bug here even file sizes changes but patient still selected
            this.props.dispatch(updateDownloadCount(someProperty))
        })
    }

    handleChangesDialogDoNotShowAgain = () => {
        this.setState({changes: {...this.state.changes, loading: true}})
	    let lastChange = this.getLastChangesID(this.state.changes.logs)
        baseApi.fullFetch("login", "put", {
            data: {last_read_changelog_id: lastChange},
            showMessageFailed: !this.state.isPublic
        }).then(()=>{
        }).catch(()=>{
        }).finally(()=> {
			this.setState({changes: {...this.state.changes, show: false, loading: false}})
	        Storage.setUserChangeLogSeen(lastChange)
        })
    };
    handleChangesLogDialogCancel = () => {
        this.setState({changes: {...this.state.changes, show: false}});
    };

    handleChangesLogDialogDiv = (item, index) => {
        return <ChangesGroup key={index} items={item} />
    };
	
	otp_verify_variable = (event) => {
		this.setState({verifyOTP: event.target.value})
	}

    otp_check_api = () => {
		baseApi.fullFetch('login', 'get', {data: {check_otp: this.state.verifyOTP}})
			.then(response => this.props.dispatch(_alert(true, 'success', response?.data?.msg)))
			.catch((xhr) => this.props.dispatch(_alert(true, 'error', xhr.response.data?.msg)))
    };
	

    render() {
        const {direction, rightOrLeft} = this.state.language === "fa" ? {direction: "rtl", rightOrLeft: "right"} : {direction: "ltr", rightOrLeft: "left"};
        const opposite = rightOrLeft === "right" ? "left" : "right";
        
        return (
            <div className={'panel'} style={{direction: direction}}>
                <header className={`panel__header ${this.state.hideByScrolling ? "show" : "hidden"}`}>
                    <div className="panel__header-container">
                        <div className={'header__info'}>
                            {user1.canViewUserSettingMenu() && <div className={'info__user'}
                                                                    onClick={() => this.handleShowDropdown(true, 'dropdown_profile')}
                                                                    onBlur={() => this.handleShowDropdown(false, 'dropdown_profile')}
                                                                    tabIndex={0}>
                                <i className="fa fa-thin fa-bars gray-it"/>
                                {(user1.canViewAddPatientButton(this.state.device)) && <div className="add__customer" onClick={this.toggleAddPatient}>
                                    <i className="fal fa-plus-circle" />
                                    <T token={'new_study'}/>
                                </div>}
                                {this.state.dropdown_profile &&
                                    <div className={`dropdown dropdown--profile ${rightOrLeft}`}>
                                        <div className={'dropdown__content dropdown__content--profile'}>
                                            <div className={'content__item'}
                                                    onClick={() => this.handleShowModal('modalSettings')}>
                                                <i className={'fa-solid fa-light fa-gear'}/>
                                                <T token={'site_settings'}/>
                                            </div>
                                            <div onMouseEnter={this.handleOpenDrillDown}
                                                    onMouseLeave={this.handleCloseDrillDown}
                                                    className={'content__item drill-down__item'}>
                                                <i className={'fa-solid fa-light fa-user'}/>
                                                <T token={'profile'}/>
                                                <i className={`fa fa-angle-${opposite} ${rightOrLeft}-auto`} />
                                                {
                                                    this.state.profileDrillDownIsOpen &&
                                                    <div className={`content__item-drilldown__menu ${rightOrLeft}`}>
                                                        <div onClick={() => this.handleShowModal('modalProfile')}
                                                                className={'content__item'}>
                                                            <i className={'fa-thin fa-key'}/>
                                                            <T token={'change_password'}/>
                                                        </div>
                                                        <div onClick={() => this.handleShowModal('modalLastSession')}
                                                                className={'content__item'}>
                                                            <i className={'fal fa-user-clock'}/>
                                                            <T token={'recent_sessions'}/>
                                                        </div>
	                                                    <div onClick={() => this.handleShowModal('modalOTP')}
	                                                         className={'content__item'}>
		                                                    <img src={otp} alt={''}/>
		                                                    <T token={'otp'}/>
	                                                    </div>
	                                                    {user.canAccessSignature() &&
		                                                    <div onClick={this.handleSignatureModal}
		                                                         className={'content__item'}>
		                                                    <i className={'fa-thin fa-file-signature'}/>
                                                            <T token={'signature'}/>
                                                        </div>}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            }

                            {!!this.state.downloadCount &&
                                <div className={'header__download'}
                                        onClick={() => this.handleShowModal('modalDownload')}>
                                    <i className={'fa fa-thin fa-download'}/>
                                    <span className={'download__text'}>{this.state.downloadCount} <T token={'item'}/></span>
                                </div>}

                        </div>

                        <div className={'header__info'}>
                            <div className={'info__organization'}>
                                {this.state.device !== "mobile" &&
                                    <div className="info__container">
                                            <i className={'fal fa-hospital-alt'}/>
                                            <span className={'info__text'}>{this.state.hospitalName}</span>
                                            { !snippets.isObjectEmpty(Storage.getUserDepartmentTitle()) && <>
                                                    <div className="seprator__line" />
                                                    <div className={'info__section'}>
                                                        <T token={"department"} /> {'\u00A0'}
                                                        {Storage.getUserDepartmentTitle()}
                                                    </div>
                                            </> }
                                </div> }
                            </div>
                        </div>
                        <div className={'header__info'}>
                            <Link className={"header__info__help__link"} to={`/help/user/`} target="_blank"
                                  onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
                                <i className="fal fa-bolt" ref={this.iconRef1}></i>
                                <span ref={this.textRef}>
                                    <T token={"user_manual"} />
                                </span>
                                <i className={'fal fa-bolt'} ref={this.iconRef2}/>
                            </Link>
                            <div className={'info__user'}>
                                <LastLogin username={this.state?.user?.display_name}/>
                            </div>

                            <div className={'info__logout'} onClick={this.handleLogout}>
                                <i className={'fa fa-thin fa-power-off'}/>
                            </div>
                        </div>
                    </div>
                </header>
                {/* <Header page={"panel"} this= {this}/> */}

                {this.state.device === "desktop" &&
                    <Navbar />
                }

                <main className={'panel__content'}>
                    <Outlet/>
                </main>

                {/* <footer className='panel__footer'></footer> */}

                {this.state.showAddPatient && <AddPatient closeModal={this.toggleAddPatient} />}

                <Modal show={this.state.modalProfile} onHide={() => this.handleCloseModal('modalProfile')}>
                    <div className={'imodal'}>
                        <div className={'imodal__header'}>
                            <div className={'imodal__close'}
                                 onClick={() => this.handleCloseModal('modalProfile')}
                            ><i className={'fa fa-light fa-times-circle'}/></div>
                            <div className={'imodal__title'}><T token={'your_profile'}/></div>
                            <div></div>
                        </div>
                        <div className={'imodal__body'}>
                            <div className={"password_change"}>
                                <Textbox changeValue={this.changeHandler}
                                         errorData={this.state.errorData}
                                         className={"pass"}
                                         name="current_password"
                                         placeholder={_.init('current_password')}
                                         showMessage={true}
                                         showLabel={true}
                                         label={<T token={'current_password'}/>}
                                         direction={_.direction()}
                                />
                                <Textbox changeValue={this.changeHandler}
                                         errorData={this.state.errorData}
                                         className={"pass"}
                                         name="password"
                                         placeholder={_.init('new_password')}
                                         showMessage={true}
                                         showLabel={true}
                                         label={<T token={'new_password'}/>}
                                         direction={_.direction()}
                                />
                                <Textbox changeValue={this.changeHandler}
                                         errorData={this.state.errorData}
                                         className={"pass"}
                                         name="confirm_password"
                                         placeholder={_.init('confirm_password')}
                                         showMessage={true}
                                         showLabel={true}
                                         label={<T token={'confirm_password'}/>}
                                         direction={_.direction()}
                                />
                                {!snippets.isObjectEmpty(this.state.serverChangePassErrors) &&
                                    <div className={"change_password_errors"} >
                                        {this.state.serverChangePassErrors}
                                    </div>
                                }
                            </div>
                            <div className={'imodal__action'}>
                                <div className={'imodal__btn imodal__btn--primary'}
                                     onClick={this.handleChangePass}><T token={'save'}/>
                                </div>
                                <div className={'imodal__btn imodal__btn--secondary'}
                                     onClick={() => this.handleCloseModal('modalProfile')}><T token={'cancel'}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal show={this.state.modalSettings} onHide={() => this.handleCloseModal('modalSettings')}>
                    <div className={'imodal imodal--settings'}>
                        <div className={'imodal__header'}>
                            <div className={'imodal__close'}
                                 onClick={() => this.handleCloseModal('modalSettings')}><i
                                className={'fal fa-times-circle'}/></div>
                            <div className={'imodal__title'}>{<T token={'public_settings'}/>}</div>
                            <div></div>
                        </div>
                        <div className={'imodal__body'}>
                            <div className={'settings__section'}>
                                <div className={'section__title'}><T token={'site'}/></div>
                                <div
                                    className={'section__content section__content--calendar section__content--bordered'}>
                                    <div className={'content__title'}><T token={'language'}/></div>
                                    <div>
                                        <label className={'option calendar__option'}>
                                            <span className={'option__title'}><T token={'farsi'}/></span>
                                            <input onChange={this.handleInputChange}
                                                   checked={this.state.language === UserSettings.LANG_FA}
                                                   type={'radio'} value={'fa'}
                                                   name={'language'}/>
                                            <span className={'option__mark'}></span>
                                        </label>
                                        <label className={'option calendar__option'}>
                                            <span className={'option__title'}>English</span>
                                            <input onChange={this.handleInputChange}
                                                   checked={this.state.language === UserSettings.LANG_EN}
                                                   type={'radio'} value={'en'}
                                                   name={'language'}/>
                                            <span className={'option__mark'}></span>
                                        </label>
                                    </div>
                                </div>
                                <div
                                    className={'section__content section__content--calendar section__content--bordered'}>
                                    <div className={'content__title'}><T token={'calendar'}/></div>
                                    <div>
                                        <label className={'option calendar__option'}>
                                            <span className={'option__title'}><T token={'jalali'}/></span>
                                            <input onChange={this.handleInputChange}
                                                   checked={this.state.calendar === UserSettings.CAL_PERSIAN}
                                                   type={'radio'}
                                                   value={'Solar Hejri'}
                                                   name={'calendar'}/>
                                            <span className={'option__mark'}></span>
                                        </label>
                                        <label className={'option calendar__option'}>
                                            <span className={'option__title'}><T token={'gregorian'}/></span>
                                            <input onChange={this.handleInputChange}
                                                   checked={this.state.calendar === UserSettings.CAL_GREGORIAN}
                                                   type={'radio'}
                                                   value={'Gregorian'}
                                                   name={'calendar'}/>
                                            <span className={'option__mark'}></span>
                                        </label>
                                    </div>
                                </div>
                                <div className={'section__content section__content--click  section__content--bordered'}>
                                    <div className={'content__title'}>
                                        <T token={'double_click'}/>
                                        <Tooltip text={"double_click_tooltip"} />
                                    </div>

                                    <select onChange={this.handleInputChange} name={'doubleClick'} value={this.state.doubleClick}>
                                        <option value={"None"}>
                                            <T token={'none'}/>
                                        </option>
                                        <option value={"Quick View"}>
                                            <T token={'quick_view'}/>
                                        </option>
                                        <option value={'Advanced View'}>
                                            <T token={'advanced_viewer'}/>
                                        </option>
                                        <option value={'Report'}>
                                            <T token={'show_report'}/>
                                        </option>
                                    </select>

                                </div>
                                <div className={'section__content '}>
                                    <CheckBox type="complex"
                                              name="can_predownload"
                                              labelText="can_predownload"
                                              disableMainLabel={true}
                                              handleChangeValue={(e) => {this.setState({preDownload : e.checked})}}
                                              checked={this.state.preDownload}
                                              transparent
                                    />
                                </div>
                            </div>

                            {user.canAccessSettingPermissionsSection() && <div className={'settings__section'}>
                                <div className={'section__title'}>
                                    <T token={'permissions'}/>
                                </div>
                                <div className={'section__content'}>
                                    <CheckBox type="complex"
                                              name="allowResidentsToVerifyWithMe"
                                              labelText="can_assistance"
                                              disableMainLabel={true}
                                              handleChangeValue={(e) => {this.setState({allowResidentsToVerifyWithMe : e.checked})}}
                                              checked={this.state.allowResidentsToVerifyWithMe}
                                              transparent
                                    />
                                </div>
                            </div>}

                            <div className={'imodal__action'}>
                                <div className={'imodal__btn imodal__btn--primary'}
                                     onClick={this.handleSaveSettings}><T token={'save'}/>
                                </div>
                                <div className={'imodal__btn imodal__btn--secondary'}
                                     onClick={() => this.handleCloseModal('modalSettings')}><T token={'cancel'}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal show={this.state.modalSignature} onHide={() => this.handleCloseModal('modalSignature')}>
                    <div className={'imodal imodal--settings'}>
                        <div className={'imodal__header'}>
                            <div className={'imodal__close'}
                                 onClick={() => this.handleCloseModal('modalSignature')}><i
                                className={'fa fa-light fa-times-circle'}/></div>
                            <div className={'imodal__title'}>{<T token={'your_signature'}/>}</div>
                            <div></div>
                        </div>
                        <div className={'imodal__body'}>
                            <div className={'imodal__action-upload'}>
                                <div className="signature-container">
                                    <img src={this.state.userSignature} alt="User signature" className="signature" />
                                </div>
                                <Uploader fieldName="signature" application="signature" onUploadCompleted={this.updateFromUploader} />
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal show={this.state.modalDownload} size="lg" onHide={() => this.handleCloseModal('modalDownload')}>
                    <div className={'imodal imodal--download'}>
                        <div className={'imodal__header'}>
                            <div className={'imodal__close'} onClick={() => this.handleCloseModal('modalDownload')}>
                                <i className={'fa fa-light fa-times-circle'}/></div>
                            {/* <div className={'imodal__title'}><T token={'can_assistance'}/></div> */}
                            <div></div>
                        </div>

                        <div className={'imodal__body'}>
                            <div className={'download__section'}>


                                {!!this.state.downloadStep3 &&
                                <div className={'section___progress'}>
                                    <div className={'progress__title'}>
                                        <div><T token={'create_final_link'}/></div>
                                        <div className={'progress__percent'}>٪{this.state.downloadPercent}</div>
                                    </div>
                                    <progress className={'progress__bar'} value={this.state.downloadPercent} max={100}/>
                                    <div className={'progress__remained'}><T token={'remaining_time'}/> : 00:00</div>
                                    <div className={'imodal__action'}>
                                        <div className={'imodal__btn imodal__btn--secondary'}><T token={'cancel'}/>
                                        </div>
                                    </div>
                                </div>
                                }


                                {!!this.state.downloadStep2 &&
                                <div className={'section__link'}>
                                    <div className={'link__title'}><T token={'download_link'}/></div>
                                    <div className={'link__content'}>
                                        <div className={'link__btn'} onClick={this.handleDownloadFile}>
                                            <T token={'download_file'}/>
                                        </div>
                                        <div className={'link__info'}>
                                            <div className={'info__item'}>--</div>
                                            <div className={'info__item'}>--</div>
                                        </div>
                                    </div>
                                    <div className={'imodal__action'}>
                                        <div className={'imodal__btn imodal__btn--secondary'} onClick={() => this.handleCloseModal('modalDownload')}><T token={'close_'}/>
                                        </div>
                                    </div>
                                </div>
                                }


                                {!!this.state.downloadStep1 &&
                                <>
                                    <div className={'section__info'}>
                                        <div className={'info__right'}>
                                            <span className={'info__key'}><T token={'selected_item'}/>:</span>
                                            <span className={'info__value'}>
                                                <span style={{color: "#FFD43B"}}>{this.state.downloadCount}</span>
                                                <T token={'item'}/>
                                            </span>
                                        </div>

                                        <div className={'info__left'}>
                                            <div>
                                                <span className={'info__key'}><T token={'total_files'}/>:</span>
                                                <span className={'info__value'}>
                                                    <span style={{color: "#FFD43B"}}>{this.state.filesCount}</span>
                                                </span>
                                            </div>
                                            <div>
                                                <span className={'info__key'}><T token={'total_amount'}/>:</span>
                                                <span className={'info__value'}>
                                                    <span style={{color: "#FFD43B"}}>{this.state.filesSize}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={'download__list'}>
                                        <table>
                                            <thead>
                                            <tr>
                                                <td><T token={'patient_id'}/></td>
                                                <td><T token={'first_name'}/></td>
                                                <td><T token={'last_name'}/></td>
                                                <td><T token={'modality'}/></td>
                                                <td><T token={'count'}/></td>
                                                <td><T token={'amount'}/></td>
                                                <td><T token={'delete'}/></td>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            {this.state.downloadFiles.map((file, index) =>
                                                <tr key={file.id}>
                                                    {/*<td>*/}
                                                    {/*    <label className="checkbox table__checkbox">*/}
                                                    {/*        <input type="checkbox"/>*/}
                                                    {/*        <span className="checkmark"></span>*/}
                                                    {/*    </label>*/}
                                                    {/*</td>*/}
                                                    <td>
                                                        <div className={'list__value'}>{file.study.id}</div>
                                                        <div className={'list__value'}>{file.study.uid}</div>
                                                    </td>
                                                    <td>
                                                        <div className={'list__value'}>{file.patient.first_name}</div>
                                                        <div className={'list__value'}>{file.patient.his_first_name}</div>
                                                    </td>
                                                    <td>
                                                        <div className={'list__value'}>{file.patient.last_name}</div>
                                                        <div className={'list__value'}>{file.patient.his_last_name}</div>
                                                    </td>
                                                    <td>
                                                        {this.initModalities(file.study.modalities)}
                                                    </td>
                                                    <td>
                                                        <div
                                                            className={'list__value'}>{file.study.file_count_cache}</div>
                                                    </td>
                                                    <td>
                                                        <div
                                                            className={'list__value'}>{Convert.B2GB(file.study.file_size_cache)}
                                                        </div>
                                                    </td>
                                                    <td>
                                                       <div className={"delete"} onClick={()=>this.deleteFromDownload(index)}>
                                                           <i className={'fa  fa-light fa-trash-can'}  />
                                                       </div>
                                                    </td>

                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className={'download__selection'}>
	                                    <div className={'selection__section selection__section--select'}>
		                                    <div className={'selection__item'}>
			                                    <div className={'selection__title'}><T token={'file_format'}/></div>
			                                    <select name={'fileType'}
			                                            key={'fileType'}
			                                            onChange={this.handleDownloadOptionChangeSelectOptions}
			                                            value={this.state.downloadOptions.fileType}>
				                                    <option value={'dcm'}>DICOM</option>
				                                    <option value={'jpg,avi'}>JPEG/AVI</option>
				                                    <option value={'jpg,mp4'}>JPEG/MP4</option>
			                                    </select>
			                                    
			                                    <div className={'selection__item'}>
				                                    <div className={'selection__title'}><T token={'media'}/></div>
				                                    <select name={'compressedFormat'}
				                                            key={'compressedFormat'}
				                                            onChange={this.handleDownloadOptionChangeSelectOptions}
				                                            value={this.state.downloadOptions.compressedFormat}>
					                                    <option value={'ZIP'}><T token={'zip_file'}/></option>
					                                    <option value={'ISO'}><T token={'iso_file'}/></option>
				                                    </select>
			                                    </div>
		                                    </div>
		                                    
		                                    <div className={'selection__item'}>
			                                    <div className={'selection__title'}><T token={'want_DICOM_viewer'}/>
			                                    </div>
			                                    <select name={'includeViewer'}
			                                            key={'includeViewer'}
			                                            onChange={this.handleDownloadOptionChangeSelectOptions}
			                                            value={this.state.downloadOptions.includeViewer}
			                                            disabled={this.state.includeViewerDisabled}
			                                            title={_.init('dicom_available_ifonlyif', this.state.language)}
			                                    >
				                                    {this.state.includeViewerOptions?.map(item =>
					                                    <option value={item} key={item}><T token={item}/></option>
				                                    )}
			                                    </select>
		                                    </div>
	                                    </div>
	                                    
	                                    <div className={'selection__section selection__section--check'}>
		                                    <div className={'check__item'}>
			                                    <label className={'checkbox'}>
                                                    <span className={'checkbox__title'}>
                                                        <T token={'want_report'}/>
                                                    </span>
                                                    <input type="checkbox"
                                                           name={"includeReport"}
                                                           onChange={this.handleDownloadOptionChangeCheckBoxes}
                                                           checked={this.state.downloadOptions.includeReport}/>
                                                    <span className={'checkmark'}></span>
                                                </label>
                                            </div>

                                            <div className={'check__item'}>
                                                <label className={'checkbox'}>
                                                    <span className={'checkbox__title'}>
                                                        <T token={'anonymous'}/>
                                                    </span>
                                                    <input type="checkbox"
                                                           name={"anonymous"}
                                                           onChange={this.handleDownloadOptionChangeCheckBoxes}
                                                           checked={this.state.downloadOptions.anonymous}
                                                    />
                                                    <span className={'checkmark'}></span>
                                                </label>
                                            </div>
                                        </div>

                                    </div>

                                    <div className={'imodal__action'}>
                                        <div className={`imodal__btn imodal__btn--primary ${this.state.disableDownloadButton ? "disable-button" : ""}`}
                                             onClick={this.handleMakeLink}>
                                            <T token={'create_download_link'}/>
                                        </div>
                                        <div className={'imodal__btn imodal__btn--secondary'}
                                             onClick={()=>this.handleCloseModal("modalDownload")}
                                             //TODO: cancel making file on server!
                                        >
                                            <T token={'cancel'}/>
                                        </div>
                                    </div>

                                    {this.state.compressPercent > 0 && <ProgressBar percent={this.state.compressPercent} />}
                                </>
                                }
                            </div>
                        </div>
                    </div>
                </Modal>

                {
                    this.state.sessionExpired && <SigninModal modalTitle={this.state.hospitalName} closeHandler={this.signinModalCloser} />
                }


                <Modal dialogClassName={`changes_log__modal`}
                       show={this.state.changes.show}
                       centered={true}
                       onHide={this.handleChangesLogDialogCancel}
                >

                    <div className={'imodal'} style={{direction: direction}}>
                        <div className={'imodal__header'}>
                            <div className={'imodal__close'}
                                 onClick={this.handleChangesLogDialogCancel}>
                                <i className={'fa fa-light fa-times-circle'}/>
                            </div>
                            <div className={'imodal__title'}>
                                <T token={"whats_new_in_update"} />
                            </div>
                        </div>

                        <div className="mmodal__body">
                            {this.state.changes.logs?.map((item, index)=> {
                                return this.handleChangesLogDialogDiv(item, index)
                            })}
                        </div>

                        <div className={'imodal__action'}>
                            <div className={'imodal__btn imodal__btn--primary'}
                                 onClick={this.handleChangesDialogDoNotShowAgain}
                            >
                                <T token={'donot_show_again'}/>
                            </div>

                            <div className={'imodal__btn imodal__btn--secondary'}
                                 onClick={this.handleChangesLogDialogCancel}
                            >
                                <T token={'close'}/>
                            </div>
                        </div>
                    </div>
                </Modal>
	            
	            {
					this.state.modalLastSession && <LastLoginModal open={this.state.modalLastSession}
					                                               closeModalProp={() => this.handleCloseModal('modalLastSession')} />
	            }
	            {
					this.state.modalOTP &&  <Modal dialogClassName={`OTP__modal`}
					                               size="lg"
							                       show={this.state.modalOTP}
							                       centered={true}
							                       onHide={()=>this.handleCloseModal('modalOTP')}
							                >
                    <div className={'imodal'} style={{direction: direction}}>
                        <div className={'imodal__header'}>
                            <div className={'imodal__close'}
                                 onClick={()=>this.handleCloseModal('modalOTP')}>
                                <i className={'fa fa-light fa-times-circle'}/>
                            </div>
                            <div className={'imodal__title'}>
                                <T token={"otp"} />
                            </div>
                        </div>

                        <div className="mmodal__body">
	                        <div>
		                        <span className={'otp_explanation'}> {_.init('otp_explanation')} </span>
		                        <img src={'/1/login?get_otp_qr_code=1'} alt={''} loading={"lazy"}/>
	                        </div>
	                        <hr />
	                        <div>
		                        <span className={'otp_explanation'}> {_.init('otp_verification_explanation')} </span>
		                        
		                         <Textbox changeValue={this.otp_verify_variable}
                                         className={"otp"}
                                         name="otp_verification"
                                         placeholder={_.init('otp')}
                                         showLabel={true}
                                         label={<T token={'otp_verification'}/>}
                                         direction={_.direction()}
		                         >
								 </Textbox>
			                     <Button className={`imodal__btn imodal__btn--primary`}
				                    size="small"
				                    customClasses="margin-2px"
				                    mode="gray-new"
				                    onClick={this.otp_check_api}
					            >
				                    <T token={'check'} />
				                </Button>
	                        </div>
                        </div>
	                    
	                    <div className={'imodal__action'}>
                            <div className={'imodal__btn imodal__btn--secondary'}
                                 onClick={() => this.handleCloseModal('modalOTP')}
                            >
                                <T token={'close'}/>
                            </div>
                        </div>
                    </div>
                </Modal>
	            }
            </div>
        );
    }
}


const mapStateToProps = state => {
    const downloadCount = state.panelHeaderReducer;
    const language = state.LangReducer.language;
    const device = state.DeviceModeReducer.mode;
    const scroll = state.panelScrollingReducer.scroll_direction;
    const changes = state.ChangesLogReducer.changes;
    return {downloadCount, language, device, scroll, changes};
};

export default connect(mapStateToProps)(withRouter(Panel));
